import React from "react";

const NotFoundPage = () => <div style={{paddingTop: 80}}>
  <h2>Not Found</h2>
</div>

export default NotFoundPage;
